export default __webpack_public_path__ + "static/richard-2bf69b0eda0542845ea79694fe502554.png";